(function () {
  if (window.__ldRestockNotifyLoaded) return;
  window.__ldRestockNotifyLoaded = true;

  var KLAVIYO_PUBLIC_KEY = 'WsGzN2';
  var KLAVIYO_REVISION = '2026-07-15';

  function openModal(modal) {
    if (!modal) return;
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    if (typeof modal.close === 'function') modal.close();
    else modal.removeAttribute('open');
  }

  function fillModal(modal, trigger) {
    var productTitle = trigger.dataset.restockProductTitle || '';
    var productHandle = trigger.dataset.restockProductHandle || '';
    var variantTitle = trigger.dataset.restockVariantTitle || '';
    var variantId = trigger.dataset.restockVariantId || '';
    var displayTitle = productTitle;

    if (variantTitle && variantTitle !== 'Default Title') {
      displayTitle += ' — ' + variantTitle;
    }

    var productLabel = modal.querySelector('[data-restock-modal-product]');
    if (productLabel) productLabel.textContent = displayTitle;

    modal.dataset.restockVariantId = variantId;

    var tags = modal.querySelector('[data-restock-tags]');
    if (tags) {
      tags.value = [
        'newsletter',
        'restock-alert',
        'restock-product-' + productHandle,
        'restock-variant-' + variantId
      ].join(',');
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-restock-trigger]');
    if (trigger) {
      var modal = document.getElementById(trigger.dataset.restockModalId);
      if (!modal) return;
      fillModal(modal, trigger);
      openModal(modal);
      return;
    }

    var closeButton = event.target.closest('[data-restock-close]');
    if (closeButton) {
      closeModal(closeButton.closest('[data-restock-modal]'));
      return;
    }

    if (event.target.matches('[data-restock-modal]')) {
      closeModal(event.target);
    }
  });

  function showSubmissionError(form, message) {
    var error = form.querySelector('[data-restock-klaviyo-error]');

    if (!error) {
      error = document.createElement('div');
      error.className = 'ld-restock-modal__errors';
      error.dataset.restockKlaviyoError = '';
      error.setAttribute('role', 'alert');
      form.insertBefore(error, form.querySelector('[type="submit"]'));
    }

    error.textContent = message;
  }

  function subscribeToKlaviyoBackInStock(email, variantId) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(KLAVIYO_PUBLIC_KEY),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      }
    ).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo back-in-stock request failed');
      return response;
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.ld-restock-modal__customer-form');
    if (!form || form.dataset.restockNativeSubmit === 'true') return;

    event.preventDefault();
    if (!form.reportValidity()) return;

    var modal = form.closest('[data-restock-modal]');
    var emailField = form.querySelector('[data-restock-email]');
    var submitButton = form.querySelector('[type="submit"]');
    var email = emailField ? emailField.value.trim() : '';
    var variantId = modal ? modal.dataset.restockVariantId : '';
    var originalButtonText = submitButton ? submitButton.textContent : '';

    if (!email || !variantId) {
      showSubmissionError(form, 'We could not identify the selected variant. Refresh the page and try again.');
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Zapisywanie...';
    }

    subscribeToKlaviyoBackInStock(email, variantId)
      .then(function () {
        form.dataset.restockNativeSubmit = 'true';
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      })
      .catch(function () {
        showSubmissionError(form, 'We could not save your notification request. Please try again in a moment.');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }
      });
  });

  function reopenSuccessfulModal() {
    var success = document.querySelector('[data-restock-modal] [data-restock-success]');
    if (!success) return;
    var modal = success.closest('[data-restock-modal]');
    openModal(modal);
    var status = modal.querySelector('.ld-restock-modal__success');
    if (status) status.focus();
  }

  function openKlaviyoBackInStockFromCollection() {
    var pageUrl;

    try {
      pageUrl = new URL(window.location.href);
    } catch (error) {
      return;
    }

    if (pageUrl.searchParams.get('ld_bis') !== '1') return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      var button = document.querySelector('#klaviyo-bis-button-container button');
      if (button && !button.disabled && button.offsetParent !== null) {
        window.clearInterval(timer);
        pageUrl.searchParams.delete('ld_bis');
        window.history.replaceState({}, '', pageUrl.pathname + pageUrl.search + pageUrl.hash);
        button.click();
        return;
      }

      if (attempts >= 120) window.clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reopenSuccessfulModal();
      openKlaviyoBackInStockFromCollection();
    }, { once: true });
  } else {
    reopenSuccessfulModal();
    openKlaviyoBackInStockFromCollection();
  }
})();
